import React from "react";
import { useNavigate } from "react-router-dom";

const QuestionPageHeader = ({
  mode = "add",
  onSubmit,
  onDelete,
  firstbread,
  secondbread,
  children,
}) => {
  const navigate = useNavigate();

  const handleCancel = (e) => {
    e.preventDefault();
    navigate(-1);
  };

  return (
    <div className="bg-white relative flex flex-wrap">
      <div className="transition-all duration-300 w-full">
        <div className="flex flex-col md:flex-row justify-between gap-1 p-0 w-full mb-0">
          <div>
            <div className="flex items-center justify-center text-center gap-2 text-sm md:text-base mb-0 flex-wrap font-semibold text-gray-900">
              <p className="text-gray-900">
                {firstbread ? firstbread : "Manage Form"}
              </p>
              <span className="text-gray-500">{`/`}</span>
              <span className="text-gray-900">
                {secondbread ? secondbread : "Form Info"}
              </span>
              {!secondbread && (
                <>
                  <span className="text-gray-500">{`/`}</span>
                  <span className="text-gray-900 font-normal">
                    {firstbread ? (
                      mode === "add" ? (
                        "Create Question Template"
                      ) : (
                        "Edit Question Template"
                      )
                    ) : (
                      <>{mode === "add" ? "Add Question" : "Edit Question"}</>
                    )}
                  </span>
                </>
              )}
            </div>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={(e) => handleCancel(e)}
              className="bg-gray-100 text-red-500 border-0 px-6 py-2 h-11 rounded-xl text-sm font-medium"
            >
              Cancel
            </button>
            {mode === "edit" && (
              <button
                onClick={onDelete}
                className="bg-red-500 text-white border-0 px-6 py-2 h-11 rounded-xl text-sm font-medium flex items-center gap-2"
              >
                Delete
              </button>
            )}
            <button
              type="submit"
              className="bg-primary text-white border-0 px-6 py-2 h-11 rounded-xl text-sm font-medium"
            >
              {firstbread ? (
                mode === "add" ? (
                  "Create Question Template"
                ) : (
                  "Update Question Template"
                )
              ) : (
                <>{mode === "add" ? "Add" : "Edit"}</>
              )}
            </button>
          </div>
        </div>
        {children && <div className="px-2 md:px-6 pb-2">{children}</div>}
      </div>
    </div>
  );
};

export default QuestionPageHeader;
